export default "__VITE_ASSET__DO6kngiO__"